/* eslint-disable no-unused-vars */
/* global G */
import { curry } from 'lib/util'
import find from 'lib/sequence/component/children/find'
import validate from 'lib/sequence/model/validate'
import { disable, enable } from 'lib/sequence/component/state/disabled'
import enableButtons from 'app/typeExtension/event/enableButtons'

/**
 * Attempts to validate and save the value of the `content` component.
 *
 * Only to be used in the module's detail action.
 *
 * @type {Gaia.AppModule.EventHandler}
 */
const saveDynamicData = async (module, component, event) => {
  const model = module[G.MODEL]
  const { dynamicData } = model[G.CHILDREN]
  const rootComponent = module[G.STATE][G.ACTION][G.COMPONENT]

  const { detail } = find(rootComponent)
  const { content: detailContent, save } = find(detail)

  await validate(model)(detailContent)

  await enableButtons(module, component, dynamicData[G.DATA])
  disable(save)

  await module[G.ADAPTER][G.UI].update(module)
}

export default curry(saveDynamicData)
